import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FloatingModal } from '../../../components/Modal';
import Input from '../../../../Account/components/Input';
import styles from './security.scss';

const propTypes = {
  show: PropTypes.bool,
  id: PropTypes.number,
  errors: PropTypes.shape(),
  list: PropTypes.shape(),

  onRename: PropTypes.func,
  onModalClose: PropTypes.func,
};

class RenameModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.setState({
        name: nextProps.list.getIn([`${nextProps.id}`, 'name']),
      });
    }
  }

  render() {
    const {
      show, id, errors,
    } = this.props;
    const {
      name,
    } = this.state;

    return (
      <FloatingModal
        isOpen={show}
        onRequestClose={() => this.props.onModalClose()}
        action={{
          onClick: () => this.props.onRename(id, name),
          text: 'Rename',
        }}
        buttonText="Cancel"
      >
        <div className={styles.modal}>
          <div className={styles.modalTitle}>Rename</div>
          <div className={styles.modalMessage}>
            <Input
              label={(
                <>
                  Name
                  {' '}
                  <small>(something so you can identify your device)</small>
                </>
)}
              id="name"
              type="text"
              onChange={(event) => this.setState({ name: event.target.value })}
              value={name}
              errors={errors}
            />
          </div>
        </div>
      </FloatingModal>
    );
  }
}

RenameModal.propTypes = propTypes;

export default RenameModal;
